var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIconNoColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1213 22.6241L26.8622 17.9209H22.2983V14.8638C22.2983 13.5777 22.9354 12.3211 24.9729 12.3211H27.077V8.316C25.8517 8.12077 24.6135 8.01515 23.3726 8C19.6162 8 17.1638 10.2561 17.1638 14.3347V17.9209H13V22.6241H17.1638V34H22.2983V22.6241H26.1213Z",
    fill: "#2AAD75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconNoColorIcon);
export default __webpack_public_path__ + "static/media/facebookIconNoColorIcon.62eeaa5b.svg";
export { ForwardRef as ReactComponent };